import React from 'react';
import { Controller } from 'react-hook-form';
import Select from "react-select";
import DepartmentTreeSelect from '../../list-department/components/department-tree-select';
import { FormSearchFunctionButtons } from '../../../components/form-search-wrapper-sarang/form-search-wrapper-sarang';

const HerdsmanSearchForm = ({ register, control, handleSubmit, onSubmit, branch, department, wMTeam, openAddDialog }) => {
    return (
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="row">
                <div className="form-group col-md-3 col-sm-6">
                    <div className="form-group">
                        <label htmlFor="input-name" className="col-form-label">Họ tên</label>
                        <input
                            id="name"
                            className="form-control"
                            type="text"
                            name="name"
                            placeholder="Nhập họ tên"
                            ref={register()}
                        />
                    </div>
                </div>
                <div className="form-group col-md-3 col-sm-6">
                    <div className="form-group">
                        <label htmlFor="input-phoneNumber" className="col-form-label">Điện thoại</label>
                        <input
                            id="phoneNumber"
                            className="form-control"
                            type="text"
                            name="phoneNumber"
                            placeholder="Số điện thoại"
                            ref={register()}
                        />
                    </div>
                </div>
                {wMTeam && (
                    <div className="form-group col-md-3 col-sm-6">
                        <label>WM</label>
                        <Controller
                            name="wMTeamId"
                            control={control}
                            render={({ onChange, value }) => (
                                <Select
                                    isClearable
                                    value={wMTeam?.map(item => ({ label: item.name, value: item.id })).find(x => x.value === value) || null}
                                    onChange={(data) => onChange(data ? data.value : null)}
                                    placeholder="Chọn WM"
                                    options={wMTeam?.map(item => ({ label: item.name, value: item.id }))}
                                    noOptionsMessage={() => "Không tồn tại"}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            )}
                        />
                    </div>
                )}
                {branch && (
                    <div className="form-group col-md-3 col-sm-6">
                        <label>Chi hội</label>
                        <Controller
                            name="branchId"
                            control={control}
                            render={({ onChange, value }) => (
                                <Select
                                    isClearable
                                    value={branch?.map(item => ({ label: item.name, value: item.id })).find(x => x.value === value) || null}
                                    onChange={(data) => onChange(data ? data.value : null)}
                                    placeholder="Chọn Chi hội"
                                    options={branch?.map(item => ({ label: item.name, value: item.id }))}
                                    noOptionsMessage={() => "Không tồn tại"}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            )}
                        />
                    </div>
                )}
                {department && (
                    <div className="form-group col-md-3 col-sm-6">
                        <label>Ban/Địa vực</label>
                        <Controller
                            name="departmentId"
                            control={control}
                            render={({ onChange, value }) => (
                                <DepartmentTreeSelect
                                    isClearable
                                    selected={department.find(x => x.value === value) || null}
                                    onChange={(data) => onChange(data ? data.value : null)}
                                    placeholder="Chọn Ban"
                                    options={department}
                                    noOptionsMessage={() => "Không tồn tại"}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            )}
                        />
                    </div>
                )}
            </div>
            <FormSearchFunctionButtons>
                <div className="row">
                    <div className="col-sm-12 pl-0">
                        <p className="text-center">
                            <button type="submit" className="btn btn-space btn-primary">Tìm kiếm</button>
                            <button className="btn btn-space btn-secondary" type="button" onClick={() => {
                                // Reset form logic can be added here if needed
                            }}>Xóa lọc</button>
                            <button
                                className="btn btn-space btn-warning"
                                onClick={(e) => {
                                    e.preventDefault();
                                    openAddDialog();
                                }}
                            >Thêm mới</button>
                        </p>
                    </div>
                </div>
            </FormSearchFunctionButtons>
        </form>
    );
};

export default HerdsmanSearchForm;
